import { AxiosInstance } from "axios"

import { ServiceResponse } from "../../../../../core/api/apiTypes"

import { CreateUpdateWorkgroup, Workgroup, WorkgroupDetails } from "./workgroupsTypes"

export enum CompanyAdminWorkgroupsQuery {
    LIST = "workgroups-for-company",
    DETAILS = "workgroup-details",
}

type WorkgroupsForCompanyParams = Readonly<{
    companyId: number
}>

export type WorkgroupsForCompanyResponse = Readonly<{
    workgroups: Workgroup[]
}>

export async function fetchWorkgroupsForCompany(
    params: WorkgroupsForCompanyParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<WorkgroupsForCompanyResponse> {
    const url = `/companies/${params.companyId}/workgroups`

    const { data } = await axios.get(url, { signal })

    return data
}

type WorkgroupForCompanyParams = Readonly<{
    workgroupId: string
}>

export type WorkgroupForCompanyResponse = Readonly<{
    workgroup: WorkgroupDetails
}>

export async function fetchWorkgroupForCompany(
    params: WorkgroupForCompanyParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<WorkgroupForCompanyResponse> {
    const url = `/workgroups/${params.workgroupId}`

    const { data } = await axios.get(url, { signal })

    return data
}

export async function createWorkgroupForCompany(
    { workgroup }: { workgroup: CreateUpdateWorkgroup },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.post(`/workgroups`, { workgroup }, { signal })
    return data
}

export async function updateWorkgroupForCompany(
    { workgroup, workgroupId }: { workgroup: CreateUpdateWorkgroup; workgroupId: string },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.post(`/workgroups/${workgroupId}`, { workgroup }, { signal })
    return data
}

type DeleteWorkgroupForCompanyParams = Readonly<{
    workgroupId: number
}>

export async function deleteWorkgroupForCompany(
    { workgroupId }: DeleteWorkgroupForCompanyParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.delete(`/workgroups/${workgroupId}`, { signal })
    return data
}
